import { getErrorDetails } from "../app/appUtils";
import { useResendCredentialsMutation } from "../features/user/userApiSlice";
import { useToast } from "./useToast";

export const useResendCredentials = () => {
  const [resendCredentials, { isLoading }] = useResendCredentialsMutation();
  const toast = useToast();

  const resend = async (email: string) => {
    try {
      const response = await resendCredentials({ email }).unwrap();
      toast.success({
        title: "Credentials Sent",
        message: response?.message ?? `Credentials sent to ${email}`,
      });
    } catch (error: any) {
      toast.error({
        title: "Failed to Resend Credentials",
        message: getErrorDetails(error).message,
      });
    }
  };

  return { resend, isLoading };
};
